import { useMemo } from 'preact/hooks'

import { FOOTER_RELATED_ENTRIES_SIZE } from '../../js/config'
import { ArticleFooter } from '../../js/components/page/Article/footer'

export default function PageFooter(props) {
  const { data } = props
  const { related } = data

  const relatedPosts = useMemo(
    () => (related || []).slice(0, FOOTER_RELATED_ENTRIES_SIZE),
    [related],
  )

  return (
    <ArticleFooter related={relatedPosts} />
  )
}
